import React, { memo } from 'react'
import { FormControl, MenuItem } from '@mui/material'

import CustomFormLabel from '../forms/customElements/CustomFormLabel'
import CustomSelect from '../forms/customElements/CustomSelect'
import InputHelperText from './InputHelperText'

const Dropdown = ({
  label,
  id,
  bottomLabel,
  errorMessage,
  successMsg,
  onChange,
  options,
  fullWidth,
  ...restProps
}) => {
  const error = Boolean(errorMessage)
  return (
    <FormControl fullWidth={fullWidth} error={error}>
      <CustomFormLabel htmlFor={id}>{label}</CustomFormLabel>
      <CustomSelect
        id={id}
        fullWidth={fullWidth}
        required
        error={error}
        onChange={onChange}
        {...restProps}
      >
        {options &&
          options.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
      </CustomSelect>
      <InputHelperText
        successMsg={successMsg}
        errorMessage={errorMessage}
        bottomLabel={bottomLabel}
      />
    </FormControl>
  )
}

Dropdown.defaultProps = {
  required: true,
  size: '',
  fullWidth: true
}

export default memo(Dropdown)
